const QUERY_KEYS = {
  SESSION: 'session',
  SESSIONS: 'sessions',
  HAPPINESS_INDEX: 'happinessIndex',
  HAPPINESS_BY_CATEGORY: 'happinessByCategory',
  DOCUMENTS: 'documents',
  CHAT_PROPOSALS: 'chatProposals',
  CHAT_GOALS: 'chatGoals',
  GOALS: 'goals',
  STARTER_GOALS: 'starterGoals',
  GOALS_CATEGORIES: 'goalCategories',
}

export default QUERY_KEYS
